import 'react-multi-carousel/lib/styles.css'

import { Button, Col, Modal, Row } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'

import Carousel from 'react-multi-carousel'
import IlustServices from '~/services/IlustServices'
import LoadingWrapper from './LoadingWrapper'
import PhotoServices from '~/services/PhotoServices'
import classNames from 'classnames'
import { setSearchRelatedTag } from '~/utils/ngkeyword'
import { useRouter } from 'next/router'
import { withI18n } from '~/hocs'

const size = 8

const RecomendItem = ({ item, className, onClick, style = {} }: any) => {
  return (
    <Col className={className}>
      <a className={classNames('p-2 flex-center mb-2', { border: item })} style={{ height: 100, ...style }} onClick={onClick}>
        <img
          src={item?.thumbnail}
          style={{
            maxWidth: '100%',
            maxHeight: 90,
          }}
        />
      </a>
    </Col>
  )
}

const RecommendSection = ({
  t,
  className,
  items = [],
  moreLink,
  title,
  seeMoreTitle,
  modalTitle,
  color,
  logoUrl,
  renderDetailLink,
  renderWaterMark,
  loading,
  noResultTitle,
}: any) => {
  const [selectedItem, setSelectedItem] = useState<any | undefined >(undefined)
  const [showModal, setShowModal] = useState(false)

  const onHide = () => {
    setShowModal(false)
  }

  const handleItemClick = (item: any) => {
    setShowModal(true)
    setSelectedItem(item)
  }

  const hasMore = items.length >= size && seeMoreTitle
  let remain = 0; let mid = items.length
  if (items.length > 0) {
    if (items.length < size) {
      remain = size - items.length - (hasMore ? 1 : 0)
    } else if (items.length === size) {
      mid -= hasMore ? 1 : 0
    } else if (items.length < size * 2) {
      remain = size * 2 - items.length - (hasMore ? 1 : 0)
    } else {
      mid -= hasMore ? 1 : 0
    }
  }

  const renderHasMore = () => {
    if (!hasMore) return <div />
    return (
      <Col className="pl-2">
        <a className="flex-center text-center flex-column border p-2 bg-secondary text-white" style={{ height: 100 }} href={moreLink} target="_blank">
          <div><i className="fas fa-plus-circle" /></div>
          <div dangerouslySetInnerHTML={{
            __html: seeMoreTitle,
          }}/>
        </a>
      </Col>
    )
  }

  return (
    <div className={className}>
      <div className="d-flex align-items-center mb-2">
        <img height="23" className="ac-mr-2" src={logoUrl}/>
        <div className="ml-2">{title}</div>
      </div>
      <LoadingWrapper loading={loading} centerScreen={false}>

        <div className="d-none d-xl-block">
          {
            items.length <= size
              ? <Row noGutters>
                {
                  items.slice(0, mid).map((item: any, i: number) =>
                    <RecomendItem
                      key={i}
                      item={item}
                      className={classNames({ 'pl-2': i > 0 })}
                      onClick={() => handleItemClick(item)}
                    />)
                }
                {renderHasMore()}
                {!!remain && [...Array(remain).keys()].map(i => <RecomendItem key={i}/>)}
              </Row>
              : <>
                <Row>
                  {
                    items.slice(0, size).map((item: any, i: number) =>
                      <RecomendItem
                        key={i}
                        item={item}
                        className={classNames({ 'pl-2': i > 0 })}
                        onClick={() => handleItemClick(item)}
                      />)
                  }
                </Row>
                <Row>
                  {
                    items.slice(size, mid).map((item: any, i: number) =>
                      <RecomendItem
                        key={i}
                        item={item}
                        className={classNames({ 'pl-2': i > 0 })}
                        onClick={() => handleItemClick(item)}
                      />)
                  }
                  { renderHasMore() }
                  {!!remain && [...Array(remain).keys()].map(i => <RecomendItem key={i}/>)}
                </Row>
              </>
          }
        </div>

        <div className="d-block d-xl-none">
          <Carousel
            responsive={{
              lg: {
                breakpoint: { max: 4000, min: 992 },
                items: 6,
              },
              md: {
                breakpoint: { max: 992, min: 572 },
                items: 4,
              },
              sm: {
                breakpoint: { max: 572, min: 0 },
                items: 2,
              },
            }}
            className="row"
          >
            {
              items.map((item: any, i: number) => <RecomendItem
                key={i}
                item={item}
                onClick={() => handleItemClick(item)}
              />)
            }
          </Carousel>
        </div>

        {(!loading && !items.length) && <div className="text-center">{noResultTitle}</div>}
      </LoadingWrapper>
      <Modal
        show={showModal}
        centered
        size="lg"
        onHide={() => onHide()}
        onExited={() => setSelectedItem(undefined)}
      >
        <Modal.Header closeButton>
          <span style={{ color }}>{modalTitle}</span>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '100vh' }}>
          <div className="text-center">
            <a href={renderDetailLink(selectedItem)} target="_blank">
              <img src={renderWaterMark(selectedItem)} alt="" style={{ maxWidth: '100%' }}/>
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <a href="http://www.unicef.or.jp/" target="_blank"><img src="https://www.ac-illust.com/main/imgs/unicef2.jpg" className="img-fluid"/></a>
          <Button href={renderDetailLink(selectedItem)} target="_blank" className="text-white hover-underline" style={{ background: color, border: color }}>{t('download_page')} ≫</Button>
        </Modal.Footer>

        <div className="text-center" style={{ color }}>写真ACはユニセフの活動を応援しています。</div>
      </Modal>
    </div>
  )
}

const RecommendService = ({ t, className, video }: any) => {
  const [illus, setIllus] = useState([])
  const [moreLink, setMoreLink] = useState(undefined)
  const [loadingIluss, setLoadingIluss] = useState(false)

  const [photos, setPhotos] = useState([])
  const [moreLinkPhoto, setMoreLinkPhoto] = useState(undefined)
  const [loadingPhotos, setLoadingPhotos] = useState(false)

  const [moreText, setMoreText] = useState<string | undefined>(undefined)

  const router = useRouter()
  const { search } = router.query

  useEffect(() => {
    setLoadingIluss(true)
    setLoadingPhotos(true)
    const q_all = video ? video.tags.map((vs: any) => vs.name).join(' ') : undefined
    const more_text = video ? setSearchRelatedTag(video.tags.map((t: any) => t.name), video.title, 'illust') : undefined
    setMoreText(more_text)

    PhotoServices.getRelated({
      url: video ? 'https://www.photo-ac.com/api/search/photo_related' : 'https://www.photo-ac.com/api/search/photo',
      q: more_text || search,
      q_all,
      more_text,
      pp: size * 2,
      more_link: video
        ? more_text ? `https://www.photo-ac.com/main/search?q=${more_text}&srt=dlrank` : undefined
        : `https://www.photo-ac.com/main/search?q=${search}&srt=dlrank`,
    })
      .then((res: any) => {
        setPhotos(res.data.items)
        setMoreLinkPhoto(res.data.request.query.more_link)
        setLoadingPhotos(false)
      })

    IlustServices.getRelated({
      url: video ? 'https://www.photo-ac.com/api/search/illust_related' : 'https://www.photo-ac.com/api/search/illust',
      q: more_text || search,
      q_all,
      pp: size * 2,
      more_text,
      more_link: video
        ? more_text ? `https://www.ac-illust.com/main/search_result.php?search_word=${more_text}` : undefined
        : `https://www.ac-illust.com/main/search_result.php?search_word=${search}&c_names[]=&srt=dlrank`,
    })
      .then((res: any) => {
        setIllus(res.data.items)
        setMoreLink(res.data.request.query.more_link)
        setLoadingIluss(false)
      })
  }, [video])

  const renderIllusDetailLink = (item?: any) => {
    return `https://www.ac-illust.com/main/detail.php?id=${item?.id}`
  }

  const renderPhotoDetailLink = (item?: any) => {
    return `https://www.photo-ac.com/main/detail/${item?.id}?title=${item?.title}`
  }

  const renderIllusWaterMark = (item?: any) => {
    return item?.watermarked_img
  }

  const renderPhotoWaterMark = (item?: any) => {
    if (!item) return undefined
    return `https://s3-ap-northeast-1.amazonaws.com/img.photo-ac/${item.filename.slice(0, 2)}/${item.filename}_w.jpg`
  }

  return (
    <div className={className}>
      <RecommendSection
        t={t}
        loading={loadingPhotos}
        className="mt-3"
        items={photos}
        title={t('photo_recommend_title')}
        seeMoreTitle={(!moreText && !search) ? undefined : t('see_more_photo_recommend', { term: video ? moreText : search })}
        modalTitle={t('photo_recommend_modal_open')}
        moreLink={moreLinkPhoto}
        color="#1d74b3"
        logoUrl="https://jp.static.ac-illust.com/main/imgs/photoAC_logo.png"
        renderDetailLink={renderPhotoDetailLink}
        renderWaterMark={renderPhotoWaterMark}
        noResultTitle={t('photo_recommend_no_result')}
      />
      <RecommendSection
        t={t}
        loading={loadingIluss}
        className="mt-3"
        items={illus}
        title={t('illus_recommend_title')}
        seeMoreTitle={(!moreText && !search) ? undefined : t('see_more_illus_recommend', { term: video ? moreText : search })}
        modalTitle={t('illus_recommend_modal_open')}
        moreLink={moreLink}
        color="#d73a4e"
        logoUrl="https://jp.static.photo-ac.com/assets/img/illustAC_logo.png"
        renderDetailLink={renderIllusDetailLink}
        renderWaterMark={renderIllusWaterMark}
        noResultTitle={t('illus_recommend_no_result')}
      />

    </div>
  )
}

export default withI18n(RecommendService)
